import { render, staticRenderFns } from "./CaseReportComments.vue?vue&type=template&id=3ba0c066&"
import script from "./CaseReportComments.vue?vue&type=script&lang=js&"
export * from "./CaseReportComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports